import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import * as React from 'react';

export default function SyteflowTerms() {
  return (
    <div style={{ background: 'white'}}>
      <Container
        id="syteflowterms"
        sx={{
          py: { sm: 8, xs: 6 },
          color: 'black',
        }}
        fixed
      >
        <Typography variant="h4" gutterBottom>
          Syteflow Terms and Conditions
        </Typography>
        <Typography variant="body2" gutterBottom>
          Effective Date: May 20, 2025
        </Typography>

        <Typography variant="h6" gutterBottom>
          1. Ownership and License
        </Typography>
        <Typography variant="body1" >
          Syteflow is a proprietary software application developed and owned by Atisalistech Solutions Private Limited (“we”, “us”, or “our”) for the benefit of Client(s). All rights not expressly granted remain with Atisalistech Solutions Private Limited or the Client(s) as applicable per contract.
        </Typography>
        <Typography variant="body1" >
          You are granted a limited, non-transferable, revocable license to use the app solely for its intended business purpose during the active project term.
        </Typography>

        <Typography variant="h6" gutterBottom>
          2. Scope of Use
        </Typography>
        <Typography variant="body1" >
          The application is to be used only for construction project management tasks including:
          <ul>
            <li>Managing worker attendance</li>
            <li>Tracking offline labour payments</li>
            <li>Monitoring construction inventory</li>
            <li>Generating site related reports</li>
          </ul>
        </Typography>
        <Typography variant="body1" >
          Unauthorized resale, reverse engineering, or duplication of the app is strictly prohibited.
        </Typography>

        <Typography variant="h6" gutterBottom>
          3. User Responsibilities
        </Typography>
        <Typography variant="body1" >
          Users must keep their credentials confidential. You are responsible for all activities under your account and agree to not misuse the platform.
        </Typography>

        <Typography variant="h6" gutterBottom>
          4. Data Usage & Privacy
        </Typography>
        <Typography variant="body1" >
          Data collected includes worker details, site information, inventory, and attendance. For full data use and retention policy, refer to our
          <a href="https://aliatis.io/products/syteflow/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'underline' }}>
            &nbsp;Privacy Policy
          </a>.
        </Typography>
        <Typography variant="body1" >
          Client(s) own the operational data. Atisalistech Solutions Private Limited may access this data only for support and maintenance purposes and is strictly forbidden from sharing data with third parties.
        </Typography>

        <Typography variant="h6" gutterBottom>
          5. Support & Maintenance
        </Typography>
        <Typography variant="body1" >
          includes bug fixes and server monitoring. Feature enhancements require new agreements or contract extensions with client(s).
        </Typography>

        <Typography variant="h6" gutterBottom>
          6. Intellectual Property
        </Typography>
        <Typography variant="body1" >
          All branding, code, and design belong to Atisalistech Solutions Private Limited unless explicitly transferred to the Client(s). Use of company assets without permission is prohibited.
        </Typography>

        <Typography variant="h6" gutterBottom>
          7. Termination
        </Typography>
        <Typography variant="body1" >
          App access may be revoked if the software is misused or if the Client(s) discontinue service or violate terms.
        </Typography>

        <Typography variant="h6" gutterBottom>
          8. Contact
        </Typography>
        <Typography variant="body1">
          For questions or support, contact us at:&nbsp;
          <a 
            href="mailto:contact@aliatis.io"
            onClick={(e) => {
              e.preventDefault();
              window.location.href = "mailto:contact@aliatis.io";
            }}
            style={{ color: 'inherit', textDecoration: 'underline' }}
          >
            contact@aliatis.io
          </a>
        </Typography>
      </Container>
    </div>
  );
}